import { Redirect } from 'expo-router';

import { IS_PRODUCTION } from '../../../config/FruitfulEnvironment';
import SimulateICTDeposit from '../../../investment/components/ict-simulation/SimulateICTDeposit';

const SimulateICTDepositScreen = () => {
    if (IS_PRODUCTION) {
        return <Redirect href="/home/investment" />;
    }

    return <SimulateICTDeposit />;
};

export default SimulateICTDepositScreen;
